import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { CtaVariantEnum } from '~/component/call-to-action/enums/variant.enum';
import { CtaWidthEnum } from '~/component/call-to-action/enums/width.enum';
import { ClassNameInterface } from '~/component/interfaces/class-name.interface';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'a[app-cta], button[app-cta]',
  templateUrl: './call-to-action.component.html',
  styleUrls: ['./call-to-action.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CallToActionComponent implements ClassNameInterface {
  @Input() public ariaLabel?: string;
  @Input() public ctaClass = '';
  @Input() public iconType?: VtmnPlayIconTypeEnum;
  @Input() public leftIconType?: VtmnPlayIconTypeEnum;
  @Input() public rightIconType?: VtmnPlayIconTypeEnum;
  @Input() public variant;
  @Input() public width = CtaWidthEnum.Fix;

  @HostBinding('class')
  public get className(): string {
    const classes = [this.ctaClass, `button--${this.variant}`];

    if (
      this.variant === CtaVariantEnum.Link ||
      this.variant === CtaVariantEnum.Link2 ||
      this.variant === CtaVariantEnum.LinkDisruptive
    ) {
      classes.push('link', `link--width-${this.width}`);
    } else {
      classes.push('button');

      if (!this.iconType || this.width === CtaWidthEnum.Square) {
        classes.push(`button--width-${this.width}`);
      }
    }

    if (this.iconType) {
      classes.push('button--icon');
    }

    return classes.join(' ');
  }
}
